export const PERMS = {
    READ: 'customer_plans.read',
    UPDATE: 'customer_plans.update',
    DELETE: 'customer_plans.delete',
    CREATE: 'customer_plans.create',
}
